import { render, staticRenderFns } from "./GlobalHero.vue?vue&type=template&id=f8c777aa&scoped=true"
import script from "./GlobalHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalHero.vue?vue&type=style&index=0&id=f8c777aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c777aa",
  null
  
)

export default component.exports